import Lottie from "lottie-react";
import React from "react";
import { Link } from "react-router-dom";
import truckAnimation from "../../assets/animations/truck-delivery.json";
import swyveryLogo from '../../assets/swyvery-logo-login.png';
import Button from '../../components/Button';
import { Input } from '../../components/Input2';
import useLoginLogics from '../../hooks/logics/auth/use-login-logics';

const Login = () => {

  const {
    isLoggingIn,
    formik
  } = useLoginLogics();

  const { values, touched, errors, handleChange, handleSubmit } = formik;

  return (
    <div className="flex items-center justify-center w-screen min-h-[100dvh] md:min-h-screen font-inter">
      <div className="flex flex-col lg:flex-row w-[92%] max-h-max md:w-[80%]  lg:min-h-[80vh] shadow-lg rounded-xl border border-primary">
        <div className="lg:flex md:flex-col md:justify-center md:items-center w-full lg:w-1/2 bg-primary text-white rounded-t-xl md:rounded-l-[0.6rem] md:rounded-tr-none p-10 relative overflow-hidden hidden">
          <Lottie
            animationData={truckAnimation}
            loop
            autoplay
            style={{ width: 200, height: 200 }}
          />

          <div className="w-full h-2 bg-road-pattern animate-road-move absolute bottom-8 left-0"></div>

          <h2 className="text-3xl md:text-4xl  font-semibold mb-4 text-center z-10 relative">Welcome back</h2>
          <p className=" text-center z-10 relative text-xl font-medium">
            Log in to your account and explore exciting brands and users.
          </p>
        </div>


        <div className="flex flex-col justify-center items-center min-h-[60vh] w-full lg:w-1/2 rounded-xl md:rounded-none bg-white md:rounded-r-xl py-12 md:px-8 shadow-md">
          <form onSubmit={handleSubmit} className="w-4/5 flex flex-col gap-6">
            <div className="flex justify-center">
              <img src={swyveryLogo} alt="Logo" />
            </div>
            <h1 className="text-2xl font-semibold text-center">Login to your account</h1>

            <Input
              onChange={handleChange}
              label="Email"
              name='email'
              value={values.email}
              type="email"
              required
              id="email"
              placeholder="example@gmail.com"
              className="h-10"
              error={touched?.email && errors?.email ? errors?.email : undefined}
            />

            <Input
              onChange={handleChange}
              label="Password"
              name='password'
              value={values.password}
              required
              id="password"
              secure
              type="password"
              placeholder="Enter your password"
              className="h-10"
              error={touched?.password && errors?.password ? errors?.password : undefined}
            />

            <div className="flex justify-end">
              <Link to={`/forgot-password?email=${values.email}`} className="text-primary underline">
                Forgot password?
              </Link>
            </div>

            <Button
              type="submit"
              isLoading={isLoggingIn}
              className="w-full py-3 mt-4 "
            >
              {isLoggingIn ? "Please wait" : "Login"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );

};

export default Login;
